export default "__VITE_ASSET__WPkw8Gl2__"